import { render, staticRenderFns } from "./CreateExpenseCategory.vue?vue&type=template&id=2baa7068"
import script from "./CreateExpenseCategory.vue?vue&type=script&lang=js"
export * from "./CreateExpenseCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports